module.exports = __webpack_public_path__ + "media/FairPY.e2ff6c42.mp4";